import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";

export default function Contact() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 pt-20">
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-r from-seafarer-orange/10 to-seafarer-purple/10">
          <div className="container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Contact Us</h1>
              <p className="text-lg text-white">
                Have questions or want to get involved? We'd love to hear from you.
              </p>
            </div>
          </div>
        </section>
        
        {/* Main contact section */}
        <ContactSection />
        
        {/* Map section */}
        <section className="py-12">
          <div className="page-container">
            <h2 className="text-2xl font-semibold mb-6 text-white">Our Location</h2>
            <div className="seafarer-card overflow-hidden rounded-lg shadow-lg animate-fade-in">
              <div className="relative w-full h-96 border border-gray-200 dark:border-gray-700">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.3522524586766!2d14.50389431543097!3d-22.955864484985194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c7133c83fb7e945%3A0x71d31a66ebe89c0b!2s5th%20Rd%2C%20Walvis%20Bay%2C%20Namibia!5e0!3m2!1sen!2sus!4v1634567890123!5m2!1sen!2sus"
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen 
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="October Seafarers United Land & Housing Federation location"
                  className="absolute inset-0"
                ></iframe>
              </div>
              
              <div className="absolute bottom-4 left-4 z-10 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md max-w-xs">
                <h3 className="text-lg font-semibold mb-2 text-seafarer-orange">October Seafarers</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  CBD, 5th Road<br />
                  Walvis Bay, ERF 25<br />
                  Namibia
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}
